export default function Footer() {
  return (
    <footer className="w-full" style={{ background: '#AAC4DC' }}>
      <div className="max-w-2xl mx-auto px-4 py-14 flex flex-col items-center gap-5">
        {/* Logo */}
        <a href="#top" className="block">
          <img
            src="https://static.readdy.ai/image/68f89381c4c7240bb69246b185e50103/eedb73b8ac242566b224f120759b9c49.png"
            alt="Uru"
            className="w-auto object-contain"
            style={{ height: '100px' }}
          />
        </a>

        {/* Address & Hours */}
        <p
          className="text-center leading-loose text-xs md:text-sm"
          style={{ color: 'rgba(255,255,255,0.85)', letterSpacing: '0.05em' }}
        >
          富山県富山市総曲輪1丁目3-9 グリーンビル 2F<br />
          【営業時間】21:00〜ラスト　※お問い合わせください。<br />【定休日】日曜日（変更あり）
        </p>

        {/* SNS */}
        <div className="flex items-center gap-4 mt-2">
          <a
            href="https://www.instagram.com/uru_sakuragi/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors"
            style={{ border: '1px solid rgba(255,255,255,0.5)', color: '#fff' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = '#fff'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.5)'; }}
          >
            <i className="ri-instagram-line text-base" />
          </a>
        </div>
      </div>

      {/* Copyright bar */}
      <div
        className="w-full py-3 text-center"
        style={{ background: '#AAC4DC', borderTop: '1px solid rgba(255,255,255,0.2)' }}
      >
        <p className="text-white text-xs tracking-wider">
          Copyright &copy; 2026 Girls Bar Uru. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
